var r=function(r,n){for(var a=-1,t=null==r?0:r.length,e=Array(t);++a<t;)e[a]=n(r[a],a,r);return e};export{r as _};
//# sourceMappingURL=_arrayMap.js.map
